import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const cb = () => `?_t=${Date.now()}`;

export const api = axios.create({ baseURL: API });

// public
export const fetchPricing = () => api.get(`/pricing${cb()}`).then((r) => r.data);
export const fetchCoupons = () => api.get(`/coupons${cb()}`).then((r) => r.data);
export const postCallback = (payload) => api.post(`/callbacks`, payload).then((r) => r.data);

// auth
export const login = (email, password) =>
  api.post(`/auth/login`, { email, password }).then((r) => r.data);

const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const fetchMe = (token) => api.get(`/auth/me${cb()}`, authHeader(token)).then((r) => r.data);

// admin CRUD
export const adminGetPricing = (t) => api.get(`/admin/pricing${cb()}`, authHeader(t)).then((r) => r.data);
export const adminCreatePricing = (t, d) => api.post(`/admin/pricing`, d, authHeader(t)).then((r) => r.data);
export const adminUpdatePricing = (t, id, d) => api.put(`/admin/pricing/${id}`, d, authHeader(t)).then((r) => r.data);
export const adminDeletePricing = (t, id) => api.delete(`/admin/pricing/${id}`, authHeader(t)).then((r) => r.data);

export const adminGetCoupons = (t) => api.get(`/admin/coupons${cb()}`, authHeader(t)).then((r) => r.data);
export const adminCreateCoupon = (t, d) => api.post(`/admin/coupons`, d, authHeader(t)).then((r) => r.data);
export const adminUpdateCoupon = (t, id, d) => api.put(`/admin/coupons/${id}`, d, authHeader(t)).then((r) => r.data);
export const adminDeleteCoupon = (t, id) => api.delete(`/admin/coupons/${id}`, authHeader(t)).then((r) => r.data);

export const adminGetCallbacks = (t) => api.get(`/admin/callbacks${cb()}`, authHeader(t)).then((r) => r.data);
